export class Constants {
  static ACCESS_TOKEN = 'authorization';
}
